import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteOnlineFeedbackApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-online-feedback'
  }

}